import React from 'react';

function highlightCode(code = '') {
  return code
    .replace(/\b(SELECT|FROM|WHERE|AND|OR|JOIN|LEFT|RIGHT|GROUP BY|ORDER BY|LIMIT|IF|ELSE|FOR|WHILE|RETURN|function|const|let|var)\b/g, '<span class="text-sky-300">$1</span>')
    .replace(/("[^"]*"|'[^']*')/g, '<span class="text-emerald-300">$1</span>')
    .replace(/(\/\/.*$)/gm, '<span class="text-slate-400">$1</span>');
}

export default function CodeBlockRenderer({ question, value, onChange }) {
  if (!question) return null;

  const optionEntries = Array.isArray(question.options)
    ? question.options.map((opt) => [opt.key, opt.text])
    : Object.entries(question.options || {});

  const code = question.code || question.question;

  return (
    <div>
      <div
        className="rounded-2xl border border-slate-600 bg-[#0b1220] p-5 text-sm font-mono leading-6 text-slate-100 shadow-inner"
        dangerouslySetInnerHTML={{ __html: highlightCode(code) }}
      />

      {question.diagram ? (
        <div className="mt-3 rounded-xl border border-white/20 bg-white p-3" dangerouslySetInnerHTML={{ __html: question.diagram }} />
      ) : null}

      <div className="mt-4 rounded-2xl border border-white/20 bg-slate-900/55 backdrop-blur-xl p-5">
        <p className="text-lg leading-8 font-cabinet text-white">{question.prompt || 'Choose the best answer:'}</p>
      </div>

      <div className="mt-4 space-y-3">
        {optionEntries.map(([key, text]) => {
          const selected = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition ${selected ? 'border-yellow-200 bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-600 text-slate-900' : 'border-white/25 bg-slate-800/60 text-white hover:border-yellow-200/70 hover:bg-slate-700/70'}`}
            >
              <span className="font-semibold mr-2">{key}.</span>
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
